import { UpdateVersionModal } from './UpdateVersionModal.component';
import template from './UpdateVersionModal.view.html';
export default (params) => {
    return {
        template,
        controller: UpdateVersionModal,
        controllerAs: '$ctrl',
        ...params,
        inputs: {
            confirm: params.confirm,
            agentBlocksThatNeedUpdate: params.agentBlocksThatNeedUpdate,
        },
    };
};
